export const getMetricConfig = () => {
    return acp_metrics;
};
